'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.waveforms.add', [])
    .controller('WaveformsAddController', AddController)
    .name;



// WEBPACK FOOTER //
// ./client/app/waveforms/add/index.js